import { experienceTranslations } from "@/lib/experienceTranslations";
import { aiTranslations } from "@/lib/aiTranslations";

export const LANGS = [
  { code: "fr", label: "FR", name: "Français" },
  { code: "en", label: "EN", name: "English" },
  { code: "es", label: "ES", name: "Español" },
];

export const translations = {
  fr: {
    ...experienceTranslations.fr,
    ...aiTranslations.fr,
    tagline: "Découvre les meilleurs lieux, activités et sorties à Valence selon ton budget et ton moment.",
    discover: "Découvrir", map: "Carte", favorites: "Favoris", profile: "Profil",
    search_placeholder: "Rechercher un lieu, un quartier…",
    intents_title: "J'ai envie de…", categories_title: "Explorer par catégorie",
    collections_title: "Nos collections", team_picks_title: "La sélection de l'équipe",
    see_all: "Tout voir", results: "résultats", result: "résultat",
    filters: "Filtres", reset: "Réinitialiser", apply: "Voir les lieux",
    budget: "Budget", distance: "Distance", open_now: "Ouvert maintenant",
    ambiance: "Ambiance", moment: "Moment", any: "Peu importe",
    near_me: "Près de moi", list_view: "Liste", map_view: "Carte",
    why_go: "Pourquoi y aller", hours: "Horaires", address: "Adresse",
    website: "Site web", phone: "Téléphone", book: "Réserver", route: "Itinéraire",
    open: "Ouvert", closed: "Fermé", closed_temp: "Fermé temporairement",
    no_hours: "Horaires non communiqués", no_budget: "Budget non précisé",
    duration: "Durée estimée", min: "min", neighborhood: "Quartier",
    add_fav: "Ajouter aux favoris", remove_fav: "Retirer des favoris",
    add_to_list: "Ajouter à une liste", my_favorites: "Mes favoris",
    my_lists: "Mes listes", create_list: "Créer une liste", list_name: "Nom de la liste",
    create: "Créer", delete: "Supprimer", empty_fav_title: "Ton carnet est vide",
    empty_fav_text: "Touche le cœur d'un lieu pour commencer ta première liste.",
    no_results_title: "Aucun lieu pour ces filtres", no_results_text: "Élargis ton budget ou la distance, ou réinitialise les filtres.",
    no_geo_title: "Localisation indisponible", no_geo_text: "Choisis un quartier comme Ruzafa ou El Carmen.",
    lang_label: "Langue", pref_budget: "Budget préféré", pref_activities: "Activités préférées",
    pref_neighborhoods: "Quartiers préférés", save: "Enregistrer", saved: "Préférences enregistrées",
    login_google: "Se connecter avec Google", logout: "Se déconnecter",
    admin: "Back-office", account: "Compte", guest: "Invité",
    login_hint: "Connecte-toi pour synchroniser tes listes (optionnel).",
    all_places: "Tous les lieux", explore: "Explorer",
    back: "Retour", places_in_collection: "lieux dans cette collection",
    quick_view: "Voir le lieu", recenter: "Recentrer",
    admin_places: "Gestion des lieux", add_place: "Ajouter un lieu", edit: "Modifier",
    save_place: "Enregistrer le lieu", admin_denied: "Accès réservé à l'administration.",
    place_not_found: "Lieu introuvable.", loading: "Chargement…",
    share: "Partager", link_copied: "Lien copié !", share_fail: "Impossible de partager", shared_list: "Parcours partagé",
    share_not_found: "Ce parcours n'existe plus.", save_to_lists: "Enregistrer dans mes listes", saved_to_lists: "Ajouté à tes listes",
    open_app: "Découvrir Vale Vale", synced: "Synchronisé sur ton compte", sync_hint: "Connecte-toi pour retrouver tes favoris sur tous tes appareils.",
    admin_collections: "Collections", admin_tab_places: "Lieux", add_collection: "Nouvelle collection", save_collection: "Enregistrer la collection",
    pick_places: "Lieux de la collection", cluster_places: "lieux",
  },
  en: {
    ...experienceTranslations.en,
    ...aiTranslations.en,
    tagline: "Discover the best places, activities and outings in Valencia based on your budget and your moment.",
    discover: "Discover", map: "Map", favorites: "Favorites", profile: "Profile",
    search_placeholder: "Search a place, a neighborhood…",
    intents_title: "I feel like…", categories_title: "Explore by category",
    collections_title: "Our collections", team_picks_title: "Team picks",
    see_all: "See all", results: "results", result: "result",
    filters: "Filters", reset: "Reset", apply: "Show places",
    budget: "Budget", distance: "Distance", open_now: "Open now",
    ambiance: "Vibe", moment: "Moment", any: "Any",
    near_me: "Near me", list_view: "List", map_view: "Map",
    why_go: "Why go", hours: "Hours", address: "Address",
    website: "Website", phone: "Phone", book: "Book", route: "Directions",
    open: "Open", closed: "Closed", closed_temp: "Temporarily closed",
    no_hours: "Hours not provided", no_budget: "Budget not specified",
    duration: "Estimated time", min: "min", neighborhood: "Neighborhood",
    add_fav: "Add to favorites", remove_fav: "Remove from favorites",
    add_to_list: "Add to a list", my_favorites: "My favorites",
    my_lists: "My lists", create_list: "Create a list", list_name: "List name",
    create: "Create", delete: "Delete", empty_fav_title: "Your notebook is empty",
    empty_fav_text: "Tap the heart on a place to start your first list.",
    no_results_title: "No places for these filters", no_results_text: "Widen your budget or distance, or reset the filters.",
    no_geo_title: "Location unavailable", no_geo_text: "Pick a neighborhood like Ruzafa or El Carmen.",
    lang_label: "Language", pref_budget: "Preferred budget", pref_activities: "Preferred activities",
    pref_neighborhoods: "Preferred neighborhoods", save: "Save", saved: "Preferences saved",
    login_google: "Sign in with Google", logout: "Sign out",
    admin: "Back-office", account: "Account", guest: "Guest",
    login_hint: "Sign in to sync your lists (optional).",
    all_places: "All places", explore: "Explore",
    back: "Back", places_in_collection: "places in this collection",
    quick_view: "View place", recenter: "Recenter",
    admin_places: "Manage places", add_place: "Add a place", edit: "Edit",
    save_place: "Save place", admin_denied: "Admin access only.",
    place_not_found: "Place not found.", loading: "Loading…",
    share: "Share", link_copied: "Link copied!", share_fail: "Unable to share", shared_list: "Shared itinerary",
    share_not_found: "This itinerary no longer exists.", save_to_lists: "Save to my lists", saved_to_lists: "Added to your lists",
    open_app: "Discover Vale Vale", synced: "Synced to your account", sync_hint: "Sign in to keep your favorites on all your devices.",
    admin_collections: "Collections", admin_tab_places: "Places", add_collection: "New collection", save_collection: "Save collection",
    pick_places: "Places in this collection", cluster_places: "places",
  },
  es: {
    ...experienceTranslations.es,
    ...aiTranslations.es,
    tagline: "Descubre los mejores lugares, actividades y salidas en Valencia según tu presupuesto y tu momento.",
    discover: "Descubrir", map: "Mapa", favorites: "Favoritos", profile: "Perfil",
    search_placeholder: "Busca un lugar, un barrio…",
    intents_title: "Me apetece…", categories_title: "Explorar por categoría",
    collections_title: "Nuestras colecciones", team_picks_title: "Selección del equipo",
    see_all: "Ver todo", results: "resultados", result: "resultado",
    filters: "Filtros", reset: "Restablecer", apply: "Ver lugares",
    budget: "Presupuesto", distance: "Distancia", open_now: "Abierto ahora",
    ambiance: "Ambiente", moment: "Momento", any: "Cualquiera",
    near_me: "Cerca de mí", list_view: "Lista", map_view: "Mapa",
    why_go: "Por qué ir", hours: "Horario", address: "Dirección",
    website: "Web", phone: "Teléfono", book: "Reservar", route: "Cómo llegar",
    open: "Abierto", closed: "Cerrado", closed_temp: "Cerrado temporalmente",
    no_hours: "Horario no disponible", no_budget: "Presupuesto no indicado",
    duration: "Duración estimada", min: "min", neighborhood: "Barrio",
    add_fav: "Añadir a favoritos", remove_fav: "Quitar de favoritos",
    add_to_list: "Añadir a una lista", my_favorites: "Mis favoritos",
    my_lists: "Mis listas", create_list: "Crear una lista", list_name: "Nombre de la lista",
    create: "Crear", delete: "Eliminar", empty_fav_title: "Tu cuaderno está vacío",
    empty_fav_text: "Toca el corazón de un lugar para empezar tu primera lista.",
    no_results_title: "No hay lugares para estos filtros", no_results_text: "Amplía tu presupuesto o distancia, o restablece los filtros.",
    no_geo_title: "Ubicación no disponible", no_geo_text: "Elige un barrio como Ruzafa o El Carmen.",
    lang_label: "Idioma", pref_budget: "Presupuesto preferido", pref_activities: "Actividades preferidas",
    pref_neighborhoods: "Barrios preferidos", save: "Guardar", saved: "Preferencias guardadas",
    login_google: "Entrar con Google", logout: "Cerrar sesión",
    admin: "Back-office", account: "Cuenta", guest: "Invitado",
    login_hint: "Inicia sesión para sincronizar tus listas (opcional).",
    all_places: "Todos los lugares", explore: "Explorar",
    back: "Volver", places_in_collection: "lugares en esta colección",
    quick_view: "Ver lugar", recenter: "Centrar",
    admin_places: "Gestión de lugares", add_place: "Añadir lugar", edit: "Editar",
    save_place: "Guardar lugar", admin_denied: "Acceso solo para administración.",
    place_not_found: "Lugar no encontrado.", loading: "Cargando…",
    share: "Compartir", link_copied: "¡Enlace copiado!", share_fail: "No se pudo compartir", shared_list: "Ruta compartida",
    share_not_found: "Esta ruta ya no existe.", save_to_lists: "Guardar en mis listas", saved_to_lists: "Añadido a tus listas",
    open_app: "Descubrir Vale Vale", synced: "Sincronizado con tu cuenta", sync_hint: "Inicia sesión para tener tus favoritos en todos tus dispositivos.",
    admin_collections: "Colecciones", admin_tab_places: "Lugares", add_collection: "Nueva colección", save_collection: "Guardar colección",
    pick_places: "Lugares de la colección", cluster_places: "lugares",
  },
};

export function localized(obj, lang) {
  if (!obj) return "";
  return obj[lang] || obj.fr || obj.en || obj.es || "";
}
